<section>
  <rappider-alert [type]="SocialMediaAlertType"
                  [showIcon]="true"
                  [title]="SocialMediaAlertTitle"
                  [description]="SocialMediaAlertDescription"></rappider-alert>
</section>
